// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"966b0fc3","673":"ebfbb1cb","767":"ef08d7b0"}[chunkId] + ".chunk.js";
};